import React from 'react'
import {withRouter, Switch, Redirect} from 'react-router-dom'
import LoadableComponent from '../../utils/LoadableComponent'
import PrivateRoute from '../PrivateRoute'


const Home = LoadableComponent(() => import('../../routes/Home/index')) //参数一定要是函数，否则不会懒加载，只会代码拆分

const lianghuaSecretList = LoadableComponent(() => import('../../routes/lianghuaSecret/list'))
const lianghuaList = LoadableComponent(() => import('../../routes/lianghua/list'))
const lianghuaPlatformList = LoadableComponent(() => import('../../routes/lianghuaPlatform/list'))
const lianghuaRecordList = LoadableComponent(() => import('../../routes/lianghuaRecord/list'))
const lianghuaTradeList = LoadableComponent(() => import('../../routes/lianghuaTrade/list'))
const recharge = LoadableComponent(() => import('../../routes/record/recharge/index'))
const withdraw = LoadableComponent(() => import('../../routes/record/withdraw/index'))
const recordchange = LoadableComponent(() => import('../../routes/record/change/index'))
const coin = LoadableComponent(() => import('../../routes/order/coin/index'))
const future = LoadableComponent(() => import('../../routes/order/future/index'))
const secondcontract = LoadableComponent(() => import('../../routes/order/secondcontract/index'))
const finance = LoadableComponent(() => import('../../routes/order/finance/index'))
const mining = LoadableComponent(() => import('../../routes/order/mining/index'))
const loan = LoadableComponent(() => import('../../routes/order/loan/index'))
const change = LoadableComponent(() => import('../../routes/order/change/index'))

const pCoin = LoadableComponent(() => import('../../routes/product/coin/index'))
const pFinance = LoadableComponent(() => import('../../routes/product/finance/index'))
const pMining = LoadableComponent(() => import('../../routes/product/mining/index'))
const pClose = LoadableComponent(() => import('../../routes/product/close/index'))

const userList = LoadableComponent(() => import('../../routes/user/list/index'))
const userCount = LoadableComponent(() => import('../../routes/user/listCount/index'))
const userRecharge = LoadableComponent(() => import('../../routes/user/recharge/index'))
const userWithdraw = LoadableComponent(() => import('../../routes/user/withdraw/index'))

const userEdit = LoadableComponent(() => import('../../routes/user/edit/index'))
const userFre = LoadableComponent(() => import('../../routes/user/fre/index'))
const userLock = LoadableComponent(() => import('../../routes/user/lock/index'))
const userAuditList = LoadableComponent(() => import('../../routes/user/auditList/index'))
const configCarousel = LoadableComponent(() => import('../../routes/config/carousel/index'))
const configSys = LoadableComponent(() => import('../../routes/config/sys/index'))
const configChannel = LoadableComponent(() => import('../../routes/config/channel/index'))
const configNotice = LoadableComponent(() => import('../../routes/config/notice/index'))
const control = LoadableComponent(() => import('../../routes/control/list/index'))



@withRouter
class ContentMain extends React.Component {
    render() {
        return (
            <div style={{ height:'100%',display:'flex',flexDirection:'column',flex:1}}>
                <Switch>
                    <PrivateRoute exact path='/home' component={future}/>

                    <PrivateRoute exact path='/home/lianghuaSecret/list' component={lianghuaSecretList}/>
                    <PrivateRoute exact path='/home/lianghua/list' component={lianghuaList}/>
                    <PrivateRoute exact path='/home/lianghuaPlatform/list' component={lianghuaPlatformList}/>
                    <PrivateRoute exact path='/home/lianghuaRecord/list' component={lianghuaRecordList}/>
                    <PrivateRoute exact path='/home/lianghuaTrade/list' component={lianghuaTradeList}/>
                    <PrivateRoute exact path='/home/record/recharge' component={recharge}/>
                    <PrivateRoute exact path='/home/record/withdraw' component={withdraw}/>
                    <PrivateRoute exact path='/home/record/change' component={recordchange}/>
                    <PrivateRoute exact path='/home/order/coin' component={coin}/>
                    <PrivateRoute exact path='/home/order/future' component={future}/>
                    <PrivateRoute exact path='/home/order/secondcontract' component={secondcontract}/>
                    <PrivateRoute exact path='/home/order/finance' component={finance}/>
                    <PrivateRoute exact path='/home/order/mining' component={mining}/>
                    <PrivateRoute exact path='/home/order/loan' component={loan}/>
                    <PrivateRoute exact path='/home/order/change' component={change}/>

                    <PrivateRoute exact path='/home/product/coin' component={pCoin}/>
                    <PrivateRoute exact path='/home/product/finance' component={pFinance}/>
                    <PrivateRoute exact path='/home/product/mining' component={pMining}/>
                    <PrivateRoute exact path='/home/product/close' component={pClose}/>
                    <PrivateRoute exact path='/home/user/list' component={userList}/>
                    <PrivateRoute exact path='/home/user/listCount' component={userCount}/>
                    <PrivateRoute exact path='/home/user/recharge' component={userRecharge}/>
                    <PrivateRoute exact path='/home/user/withdraw' component={userWithdraw}/>
                    <PrivateRoute exact path='/home/user/edit' component={userEdit}/>
                    <PrivateRoute exact path='/home/user/fre' component={userFre}/>
                    <PrivateRoute exact path='/home/user/lock' component={userLock}/>
                    <PrivateRoute exact path='/home/user/auditList' component={userAuditList}/>

                    <PrivateRoute exact path='/home/control/list' component={control}/>

                    <PrivateRoute exact path='/home/config/carousel' component={configCarousel}/>
                    <PrivateRoute exact path='/home/config/sys' component={configSys}/>
                    <PrivateRoute exact path='/home/config/channel' component={configChannel}/>
                    <PrivateRoute exact path='/home/config/notice' component={configNotice}/>

                    {/*<PrivateRoute exact path='/home/costsetting/coupon' component={Coupon}/>*/}
                    {/*<PrivateRoute exact path='/home/costsetting/Preferential' component={Preferential}/>*/}
                    {/*<PrivateRoute exact path='/home/costsetting/purchase' component={Purchase}/>*/}




                    <Redirect exact from='/' to='/home'/>

                </Switch>
            </div>
        )
    }
}

export default ContentMain



// WEBPACK FOOTER //
// ./src/components/ContentMain/index.js